import { SUPPORT } from 'app/route-constants';
import { articlePropTypes } from 'app/selectors/support';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import { components } from '@glowforge/ui-common';
import Steps from './entries/steps';
import TextEntry from './entries/text-entry';

import './article.less';

const { Markdown } = components;

const Article = (props) => {
  // TODO: Check here for different entry types
  const entries = _.map(_.get(props, 'fields.entries'), (entry, index) => {
    const contentType = _.get(entry, 'sys.contentType.sys.id');

    // If Content type isn't supported, skip
    if (!_.includes(SUPPORT.SUPPORT_ENTRY_TYPES, contentType)) return null;

    switch (contentType) {
      case 'questionAndAnswer':
      case 'supportEntryTextAndMedia':
        return (
          <li key={index}>
            <TextEntry {...entry.fields} unboxingUpdateEnabled={props.unboxingUpdateEnabled} />
          </li>
        );
      case 'supportEntryInstructions':
        return (
          <li key={index}>
            <Steps {...entry.fields} unboxingUpdateEnabled={props.unboxingUpdateEnabled} />
          </li>
        );
      case 'supportEntryTipOrAlert':
        return (
          <li key={index} className='tip-or-alert'>
            <div className={entry.fields.tip ? 'tip-block' : 'alert-block'}>
              <Markdown className='text paragraph' source={entry.fields.text} />
            </div>
          </li>
        );
      default:
        return null;
    }
  });

  const getTitle = () => (
    props.unboxingUpdateEnabled ? (
      <h3 className='articleTitle'>{_.get(props, 'fields.sectionHeader')}</h3>
    ) : (
      props.topicTitle && (
        <React.Fragment>
          <Helmet title={`${props.topicTitle} - ${_.get(props, 'fields.title')}`} />
          <h2 className='h1'>{_.get(props, 'fields.title')}</h2>
        </React.Fragment>
      )
    )
  );

  return (
    <div className='Article'>
      {getTitle()}
      <ul className='entries'>
        {entries}
      </ul>
    </div>
  );
};

Article.propTypes = {
  ...articlePropTypes,
  topicTitle: PropTypes.string,
  unboxingUpdateEnabled: PropTypes.bool,
};

Article.defaultProps = {
  unboxingUpdateEnabled: false,
};

Article.defaultProps = {
  topicTitle: '',
};

export default Article;



// WEBPACK FOOTER //
// ./app/components/support/article.jsx